import React, { useState } from "react";
import emailjs from "emailjs-com";
import Fade from "react-reveal/Fade";

import IconAddress from "assets/images/icons/ic_address.svg";
import IconTelp from "assets/images/icons/ic_telp.svg";
import IconEmail from "assets/images/icons/ic_email.svg";
import IconFB from "assets/images/icons/ic_fb.png";
import IconIG from "assets/images/icons/ic_ig.png";
import IconTktok from "assets/images/icons/ic_tiktok.png";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_c81sssg",
        "template_qhg5wc5",
        {
          from_name: formData.name,
          from_phone: formData.phone,
          from_email: formData.email,
          message: formData.message,
        },
        "YE2REHFCjYrtlulkk"
      )
      .then(
        () => {
          alert("Pesan berhasil dikirim!");
          setFormData({ name: "", phone: "", email: "", message: "" });
        },
        () => {
          alert("Gagal mengirim pesan, coba lagi.");
        }
      );
  };

  return (
    <section className="container mt-md-5" style={{ color: "#696969" }}>
      <div className="row gy-5 my-5 align-items-start">
        {/* === Info Kontak === */}
        <Fade left>
          <div className="col-12 col-md-6 pe-md-5 px-3">
            <h4 className="text-center text-md-start" style={{ color: "#333333" }}>Siap Bantu Liburan Anda</h4>
            <p className="lead text-center text-md-start" style={{ fontSize: "1rem" }}>
              Ada pertanyaan atau mau reservasi? <br /> Tim kami siap membantu!
            </p>

            <div className="d-flex align-items-start mt-3">
              <img src={IconTelp} alt="telepon-GH" height={35} className="me-3" />
              <p className="lead mb-0" style={{ fontSize: "1rem" }}>
                <span className="fw-bold">Whatsapp</span> <br />
                0813-1731-1631
              </p>
            </div>

            <div className="d-flex align-items-start mt-3">
              <img src={IconEmail} alt="email-GH" height={35} className="me-3" />
              <p className="lead mb-0" style={{ fontSize: "1rem" }}>
                <span className="fw-bold">Email</span> <br />
                adminGH@kemuninggroup.co.id
              </p>
            </div>

            <div className="d-flex align-items-start mt-3">
              <img src={IconAddress} alt="address-GH" height={35} className="me-3" />
              <p className="lead mb-0" style={{ fontSize: "1rem" }}>
                <span className="fw-bold">Alamat Green Hill Resort</span> <br />
                Cipanas - Puncak Bogor. Ciherang, Kec. Pacet, Jawa Barat 43253
              </p>
            </div>

            <p className="text-center text-md-start fw-bold mt-4" style={{ fontSize: "1rem" }}>
              Ikuti media sosial kami
            </p>
            <div className="d-flex gap-3 mt-2 justify-content-center justify-content-md-start">
              <a
                href="https://www.facebook.com/GreenHillKemuning"
                target="_blank"
                rel="noreferrer"
              >
                <img src={IconFB} alt="fb-GH" width={30} />
              </a>
              <a
                href="https://www.instagram.com/villa_greenhillresort/?hl=id"
                target="_blank"
                rel="noreferrer"
              >
                <img src={IconIG} alt="ig-GH" width={30} />
              </a>
              <a
                href="https://www.tiktok.com/@villa.greenhillkemuning"
                target="_blank"
                rel="noreferrer"
              >
                <img src={IconTktok} alt="tiktok-GH" width={30} />
              </a>
            </div>
          </div>
        </Fade>

        {/* === Form Pesan === */}
        <Fade right>
          <div className="col-12 col-md-6 px-3 d-flex justify-content-center">
            <div
              className="card p-4 shadow-lg w-100"
              style={{ borderRadius: "20px" }}
            >
              <h4 style={{ color: "#333333" }}>Kirim Pesan Sekarang</h4>
              <form className="mt-3" onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-12 col-md-6">
                    <label className="form-label">Nama Lengkap</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Masukkan nama lengkap"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-12 col-md-6">
                    <label className="form-label">Telepon</label>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Masukkan nomor telepon"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="mt-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Masukkan email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mt-3">
                  <label className="form-label">Pesan</label>
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Tulis pesan Anda..."
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn w-100 text-white mt-3"
                  style={{ backgroundColor: "#696969", borderColor: "#696969" }}
                >
                  Kirim Pesan
                </button>
              </form>
            </div>
          </div>
        </Fade>
      </div>
    </section>
  );
}
